module.exports = __webpack_public_path__ + "static/media/searchmagnifier.fb995407.svg";